module.exports = __webpack_public_path__ + "static/img/weiguanwang4.411c06c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/weiguanwang4.png
// module id = N2tf
// module chunks = 52